module.exports = __webpack_public_path__ + "static/media/cash-funds-alt.9a89136a.svg";